import { render, staticRenderFns } from "./SlicesSeparator.vue?vue&type=template&id=312ba6cc&scoped=true"
import script from "./SlicesSeparator.vue?vue&type=script&lang=js"
export * from "./SlicesSeparator.vue?vue&type=script&lang=js"
import style0 from "./SlicesSeparator.vue?vue&type=style&index=0&id=312ba6cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312ba6cc",
  null
  
)

export default component.exports